<template>
	<BaseButton
		v-if="canGoBack && showButton"
		:classes="props.classes"
		:disabled="isDisabled"
		:mixpanel-custom-properties="props.mixpanelCustomProperties"
		@click="goToNextStep"
	>
		<BaseSvgIcon v-if="displayIcon" name="chevron" dir="left" width="24" height="24" />
		<span :class="appStore.isMobile ? 'body-sm' : 'body-md'">Back</span>
	</BaseButton>
</template>
<script setup lang="ts">
import { computed, onMounted, ref } from 'vue';
import { getNextRoute } from '@utils/checkout';
import { MixpanelContext } from 'types/analytics';
import { useAppStore } from '@stores/app';
import { useRouter } from 'vue-router';
import { useSignupStore } from '@stores/signup';

interface Props {
	disabled?: boolean;
	mixpanelCustomProperties?: MixpanelContext;
	classes?: string;
	displayIcon?: boolean;
}

const appStore = useAppStore();
const signupStore = useSignupStore();

const props = withDefaults(defineProps<Props>(), {
	disabled: false,
	mixpanelCustomProperties: undefined,
	classes: 'button button-ghost',
	displayIcon: false
});

const router = useRouter();
const isLoading = ref(true);

const isDisabled = computed(() => props.disabled);

const canGoBack = computed((): boolean => !!signupStore.signupCheckoutSelections?.previousStep?.isBackwardsNavigable);

const showButton = computed((): boolean => {
	return !isLoading.value;
});

onMounted(() => {
	isLoading.value = false;
});

async function goToNextStep(): Promise<void> {
	try {
		const previousStepName = await getNextRoute(signupStore.signupCheckoutSelections?.previousStep);
		await router.push(previousStepName);
	} catch {}
}
</script>
